var exhTBSUNYC_1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_1.jpg';
var exhTBSUNYC_2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_2.jpg';
var exhTBSUNYC_3 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_3.jpg';
var exhTBSUNYC_4 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_4.jpg';
var exhTBSUNYC_5 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_5.jpg';
var exhTBSUNYC_6 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_6.jpg';
var exhTBSUNYC_7 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_7.jpg';
var exhTBSUNYC_8 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_8.jpg';
var exhTBSUNYC_9 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_9.jpg';
var exhTBSUNYC_10 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_10.jpg';
var exhTBSUNYC_11 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_11.jpg';
var exhTBSUNYC_12 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_12.jpg';
var exhTBSUNYC_13 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_13.jpg';
var exhTBSUNYC_14 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_nyc/exhTBSUNYC_14.jpg';

export const allImagesDesktopOrderExhTBSUNYC = [
    [/*COLUMN 1*/
        [
            {
                name: exhTBSUNYC_1,
                captionln1: "The banners announcing the solo exhibition, <b>The Space Between Us</b>, outside Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc1"
            },
        ],
        [
            {
                name: exhTBSUNYC_2,
                captionln1: "<b>The Space Between Us</b> solo exhibition catalogue with an Introduction by Lou Zona and an essay by Peter Balakian.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc2"
            },
        ],
        [
            {
                name: exhTBSUNYC_3,
                captionln1: "The wall text at Gerald Peters Gallery during the solo exhibition, <b>The Space Between Us</b>.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc3"
            },
        ],
        [
            {
                name: exhTBSUNYC_4,
                captionln1: "The gallery space right before the opening of <b>The Space Between Us</b> at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc4"
            },
        ],
        [
            {
                name: exhTBSUNYC_6,
                captionln1: "The opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc6"
            },
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: exhTBSUNYC_5,
                captionln1: "An impromptu RISD reunion with wonderful artists at the opening of <b>The Space Between Us</b> in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc5"
            },
        ],
        [
            {
                name: exhTBSUNYC_7,
                captionln1: "The wall of ceramic vessels in the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc7"
            },
        ],
        [
            {
                name: exhTBSUNYC_9,
                captionln1: "At the opening  of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc9"
            },
        ],
        [
            {
                name: exhTBSUNYC_8,
                captionln1: "The ceramic vessels shown alongside paintings and drawing in the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc8"
            },
        ],
        [
            {
                name: exhTBSUNYC_10,
                captionln1: "At the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc10"
            },
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: exhTBSUNYC_11,
                captionln1: "At the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc11"
            },
        ],
        [
            {
                name: exhTBSUNYC_12,
                captionln1: "At the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc12"
            },
        ],
        [
            {
                name: exhTBSUNYC_13,
                captionln1: "At the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc13"
            },
        ],
        [
            {
                name: exhTBSUNYC_14,
                captionln1: "Standing in front of the painting, Attached, the night of the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_nyc14"
            },
        ]
    ]          
]

export const allImagesMobileOrderExhTBSUNYC = [
    [{
        name: exhTBSUNYC_1,
        captionln1: "The banners announcing the solo exhibition, <b>The Space Between Us</b>, outside Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc1"
    },
    {
        name: exhTBSUNYC_2,
        captionln1: "<b>The Space Between Us</b> solo exhibition catalogue with an Introduction by Lou Zona and an essay by Peter Balakian.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc2"
    },
    {
        name: exhTBSUNYC_3,
        captionln1: "The wall text at Gerald Peters Gallery during the solo exhibition, <b>The Space Between Us</b>.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc3"
    },
    {
        name: exhTBSUNYC_4,
        captionln1: "The gallery space right before the opening of <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc4"
    },
    {
        name: exhTBSUNYC_6,
        captionln1: "The opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc6"
    },
    {
        name: exhTBSUNYC_5,
        captionln1: "An impromptu RISD reunion with wonderful artists at the opening of <b>The Space Between Us</b> in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc5"
    },
    {
        name: exhTBSUNYC_7,
        captionln1: "The wall of ceramic vessels in the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc7"
    },
    {
        name: exhTBSUNYC_9,
        captionln1: "At the opening  of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc9"
    },
    {
        name: exhTBSUNYC_8,
        captionln1: "The ceramic vessels shown alongside paintings and drawing in the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc8"
    },
    {
        name: exhTBSUNYC_10,
        captionln1: "At the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc10"
    },
    {
        name: exhTBSUNYC_11,
        captionln1: "At the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc11"
    },
    {
        name: exhTBSUNYC_12,
        captionln1: "At the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc12"
    },
    {
        name: exhTBSUNYC_13,
        captionln1: "At the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc13"
    },
    {
        name: exhTBSUNYC_14,
        captionln1: "Standing in front of the painting, Attached, the night of the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_nyc14"
    }]      
]
